import { render, staticRenderFns } from "./ToggleCollapseButton.vue?vue&type=template&id=18676c8a&scoped=true&lang=pug&"
import script from "./ToggleCollapseButton.vue?vue&type=script&lang=ts&"
export * from "./ToggleCollapseButton.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleCollapseButton.vue?vue&type=style&index=0&id=18676c8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18676c8a",
  null
  
)

export default component.exports